import { cn } from '@moreharvest/component-library';
import { Lot } from '@models/api/user/portfolio';
import { USDFormatterWhole } from '@utils/currency';

const getGainClasses = (gain: number) =>
    cn(
        'w-full text-end',
        gain === 0 && 'text-base-black dark:text-base-white',
        gain > 0 && 'text-interaction-success',
        gain < 0 && 'text-neutral-500 dark:text-neutral-500-dark'
    );

const LotRowData = ({
    shares,
    costBasis,
    gainLoss,
}: Pick<Lot, 'shares' | 'costBasis' | 'gainLoss'>) => {
    return (
        <ul
            className="flex w-full px-4 py-2 rounded-lg
        bg-neutral-50 dark:bg-neutral-50-dark border-1
        border-neutral-100 dark:border-neutral-100-dark items-center Body-Small
        "
        >
            <li className="w-full text-start">{shares}</li>
            <li className="w-full text-center">
                {USDFormatterWhole.format(costBasis)}
            </li>
            <li className={getGainClasses(gainLoss)}>
                {gainLoss > 0 && '+'}
                {USDFormatterWhole.format(gainLoss)}
            </li>
        </ul>
    );
};

export default LotRowData;
